const globalStyleId = 'gs-text-main';
const globalStyleCurrentPageId = 'gs-text-main-current-page';
const defaultSelector = {
  selector: '#{mID} .gf_breadcrumbs',
};
const defaultSelectorCurrentPage = {
  selector: '#{mID} .gf_breadcrumbs-link.gf_current-page',
};
export default {
  defaultClass: 'gf_gs-text-paragraph-2',
  settingGroups: {
    [globalStyleId]: {
      fontWeight: {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
    [globalStyleCurrentPageId]: {
      'page-font-weight': {
        ...defaultSelectorCurrentPage,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'page-font-size': {
        ...defaultSelectorCurrentPage,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
    },
  },
};

export const BREADCRUMBS_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
  },
  {
    gsId: globalStyleCurrentPageId,
    gsSettingGroup: 'Current Page',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
  },
];
